import { useEffect, useState } from 'react';

import mapboxgl from 'mapbox-gl';

export function useZoomPrompt(map: mapboxgl.Map, minZoom: number) {
  const [zoomPrompt, setZoomPrompt] = useState(true);

  const updateZoomPrompt = () => {
    if (!map) return;
    setZoomPrompt(map.getZoom() < minZoom);
  };

  useEffect(() => {
    if (!map) return;

    map.on('zoomend', updateZoomPrompt);
    updateZoomPrompt();

    return () => {
      map.off('zoomend', updateZoomPrompt);
    };
  }, [map]);

  return zoomPrompt;
}
